import BillingToggle from "./components/BillingToggle";
import PricingGrid from "./components/PricingGrid";
import { MARKETPLACE_PLANS } from "./data/pricing.config";
import { useBillingCycle } from "./hooks/useBillingCycle";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

const PricingPage = () => {
  const { cycle, setCycle } = useBillingCycle();

  return (
    <>
      <Navbar />
      <div className="max-w-6xl mx-auto px-6 py-16 text-center">
        <h1 className="md:text-4xl text-2xl font-bold">
          Supercharge your Influencer Marketing
        </h1>

        <BillingToggle cycle={cycle} setCycle={setCycle} />

        <PricingGrid plans={MARKETPLACE_PLANS} cycle={cycle} />
      </div>
      <Footer />
    </>
  );
};

export default PricingPage;
